const $ = window.jQuery;
const $window = window.$window || $(window);
const $document = window.$document || $(document);

const ChangelogModal = {

    init() {
        var $module = $('.ChangelogModal');
        if (!$module.length)
            return;

        $module.each((index, element) => {
            this.each(element);
        });
    },

    each(element) {

        let $item = $(element);

        // todo - this is slapped in from the inline JS.
        window.Hookturn = window.Hookturn || {};
        window.Hookturn.ChangelogModal = new ChangelogModal('.ChangelogModal');
        window.Hookturn.ChangelogModal.init();

        $('.js-open-changelog-modal').on('click', function (e) {
            e.preventDefault();
            $window.trigger('hookturn/open_changelog_modal');
        });

        function ChangelogModal(selector) {
            var root = this;
            this.$el = $(selector);

            this.init = function () {
                $window.on('hookturn/open_changelog_modal', function () {
                    root.reveal();
                });
            };
            this.reveal = function () {
                root.$el.removeClass('hidden');
                root.$el.on('click', '.ChangelogModal__close', root.hide);
                root.$el.on('click', '.ChangelogModal__overlay', root.hide);
                $document.on('keyup', root.on_escape);
            }
            this.hide = function () {
                root.$el.addClass('hidden');
                root.$el.off('click', '.ChangelogModal__close', root.hide);
                root.$el.off('click', '.ChangelogModal__overlay', root.hide);
                $document.off('keyup', root.on_escape);
            }
            this.on_escape = function (event) {
                if (event.key === "Escape") {
                    root.hide();
                }
            }
        }

    }

};

export default ChangelogModal;